export default {
    editTitle: 'Edit User',
    editSubtitle: 'Modify user role and permissions',
};